var window=global;var $CLJS=require("./cljs_env");require("./goog.base.js");
$CLJS.HA=require("ttag");module.exports=$CLJS.HA;